<template>
  <div class="container">
    <div class="row">
      <div class="col-fluid mx-auto">
        <div class="list-group shadow-sm mx-auto mb-5">
          <div class="list-group-item">
            <div class="d-flex justify-content-between align-items-start">
              <h3>Application Access</h3>
            </div>
            <div>Request or manage access to the applications below.</div>
          </div>
          <router-link
            v-for="app in productionApps"
            :key="app.id"
            class="list-group-item list-group-item-action d-flex justify-content-between"
            :to="getPath(app)"
          >
            <strong>{{ app.title }}</strong>
            <UnlockedIcon v-if="hasAccess(app)" style="fill: #555;" />
            <LockedIcon v-else style="fill: #555;" />
          </router-link>
          <div class="list-group-item"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LockedIcon from "../assets/lock.svg"
import UnlockedIcon from "../assets/unlock.svg"
export default {
  components: {
    LockedIcon,
    UnlockedIcon,
  },
  props: {
    apps: { required: true, type: Array },
  },
  computed: {
    productionApps() {
      return this.apps.filter((a) => a.environment === "prod")
    },
  },
  methods: {
    hasAccess(app) {
      return app.user_roles.length && !app.user_roles.includes("requester")
    },
    getPath({ user_roles, cognito_id }) {
      const action = user_roles.includes("auth_admin") ? "manage" : "request"
      return `/${action}/${cognito_id}`
    },
  },
}
</script>
